import React from 'react';
import { useForm } from 'react-hook-form';
import { Link, useParams } from 'react-router-dom';
import { useHistory } from 'react-router';

import { NewsFeedLogin } from '../../components/content/newsFeedLogin';
import { LoginHeader } from '../../components/header/loginHeader';	
import { useAuthPageLayout } from '../../hooks/useAuthPageLayout.js';
import { FormField } from '../../components/user-form/form-field.jsx';

import userService from '../../services/UserService/user-service.js';
import { useTranslation, Trans } from 'react-i18next';

export default function TrocaSenha(props) {
	const settings = useAuthPageLayout();
	const { push } = useHistory();
	const { t } = useTranslation();

	const { watch, register, handleSubmit, formState: { errors, isSubmitting } } = useForm();

	const { token } = useParams();

	const newPasswordOptions = {
		password: {
            required: t('registerOptions.obrigatorio'),
            minLength: {
              value: 8,
              message: t('registerOptions.minDigito', {x: 8})
            },
          },
          confirmPwd: {
              validate: (val) => {
                  if (watch('password') != val) {
                    return t('registerOptions.naoConfere');
                  }
                }
          }
	}

	const handleFormSubmit = (data) => { 
		return userService.basicFindUser(token).then(
			response => {
				if(response.data === "ExpiredToken"){
					settings.handleSetAlert('danger', t('alerta.titulo.erro'), t('user.alterarSenha.alerta.tokenExpirado'));
					push('/acesso');
				}
				else{
					userService.newPassword(data, response.data.email).then(
						response => {
							settings.handleSetAlert('success', t('alerta.titulo.sucesso'), t('user.alterarSenha.alerta.sucesso'));
							push('/acesso');
						}
					).catch((err) => {
						console.log(err);
						settings.handleSetAlert('danger', t('alerta.titulo.erro'), t('alerta.algoDeuErrado.mensagem'));
					})
				}
			}
		)
	}

	return (
		<div className="login login-with-news-feed">
			<div className="login-container">
				<LoginHeader title={t('user.alterarSenha.titulo')} />

				<div className="login-content">
					<form onSubmit={handleSubmit(handleFormSubmit)} className="fs-13px">
						<FormField name="password" type="password" label={t('userInfo.senha')} placeholder="Senha" register={register} options={newPasswordOptions.password} error={errors?.password} showPasswordLabel={t('botão.mostrarSenha')} hidePasswordLabel={t('botão.ocultarSenha')} />
                        <FormField name="confirmPwd" type="password" label={t('userInfo.confirmeSenha')} placeholder="Confirme a senha" register={register} options={newPasswordOptions.confirmPwd} error={errors?.confirmPwd} showPasswordLabel={t('botão.mostrarSenha')} hidePasswordLabel={t('botão.ocultarSenha')} />
						<div className="mb-15px">
							<button type="submit" 
									disabled={isSubmitting}
									className="btn btn-primary d-block h-35px w-100 btn-lg fs-14px" >
									{
										isSubmitting ?
											(<i className="fas fa-spinner fa-pulse"></i>):
											t('botão.enviar')
									}
							</button>
						</div>
					</form>
				</div>
			</div>

			<NewsFeedLogin bgImg='url(/assets/img/login-bg/login-3.jpeg)' />
		</div>	
	)
}